var map = {
	"./avatar.png": "3800",
	"./calendar.png": "dc48",
	"./documentAdd.png": "3e5a",
	"./documentDelete.png": "fc56",
	"./documentForbidden.png": "17b4",
	"./error.png": "81da",
	"./icon_show-all-locations-black.png": "ac55",
	"./icon_show-all-locations-white.png": "3287",
	"./micad-servicemark-ipr3.png": "39c9",
	"./micad-servicemark-mac.png": "6e2f",
	"./popover-icon-close.png": "b180",
	"./widget-drag.png": "ad45",
	"./widget-gear.png": "4dac",
	"./widget-remove.png": "dd03",
	"./widgetIcon-area36x36.png": "bf8d",
	"./widgetIcon-bar36x36.png": "2c98",
	"./widgetIcon-column36x36.png": "2ad1",
	"./widgetIcon-gauge36x36.png": "497d",
	"./widgetIcon-line36x36.png": "3ae3",
	"./widgetIcon-money36x36.png": "5217",
	"./widgetIcon-number36x36.png": "8bc0",
	"./widgetIcon-pie36x36.png": "3123",
	"./widgetIcon-progress36x36.png": "0f9e",
	"./widgetIcon-table36x36.png": "c101",
	"./widgetIcon-text36x36.png": "2c62",
	"./widgetIcon-traffic36x36.png": "4c8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edb2";